<template>
  <div class="Document">

    <div class="Navbar">
    <section class="hero is-white is-fullwidth" style="text-align:start">
      <div class="hero-body" style="border-bottom: medium solid #4a4a4a;">
        <div class="container">
          <h1 class="title">ドキュメント</h1>
          <h2 class="subtitle">アプリケーションの説明</h2>
        </div>
      </div>
    </section>
    </div>


    <section class="hero is-white">
      <div class="columns">
        <div class="column is-1"></div>
        <div class="column is-10">
          <br>
          <article class="message is-large">
            <div class="message-header">
              <p>はじめに</p>
            </div>
            <div class="message-body">
              このアプリは様々なじゃんけんプログラムに対して、自ら書いた
              <strong>Python</strong>という言語の
              <br />プログラムコードを書きじゃんけん対決をするものです。
            </div>
          </article>

          <article class="message is-large">
            <div class="message-header">
              <p>標準で使用可能な変数</p>
            </div>
            <div class="message-body">
              このアプリは標準で使用できる変数が準備されています。
            </div>
          </article>
          <article class="message is-dark">
            <div class="message-body">
              標準変数
              <br />
              <strong>E</strong>・・・敵の配列,
              <br />
              <strong>P</strong>・・・味方の配列,
              <br />
              <strong>WIN</strong>・・・勝利の数,
              <br />
              <strong>LOSE</strong>・・・敗北の数,
              <br />
              <strong>DROW</strong>・・・引き分けの数,
              <br />
              <strong>COUNT</strong>・・・対戦数,
              <br />
              <strong>HAND</strong>・・・０がグー、１がチョキ、２がパー
            </div>
          </article>
        </div>
        <div class="column is-1"></div>
      </div>
    </section>
  </div>
</template>
<script>
const config = {
  headers: {
    "Content-Type": "application/json"
  }
};
import axios from "axios";
export default {
  name: "Document",
  data() {
    return {
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
box {
  margin-top: 10px;
}
h1 {
  margin-top: 20px;
  font-size: 30px;
  text-align: left;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
